//chapter1
export default {
    id : 7,//chapter number
    title : '07. FMEA 5판 (2) - FMEA 5판의 양식과 정보구조',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c07.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'FMEA 양식',
                'FMEA 정보구조',
            ],
            body2 : [
                'FMEA 양식에 대해 설명할 수 있다.',
                'FMEA 정보구조에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '07.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : 'FMEA 5판에 의한 작성은 작성기업의 선택에 따른다.',//html available
                    answer : "2",
                    explain : '기본적으로 고객의 요구에 의해 결정된다.'
                },
                {
                    type : 'ox',
                    question : 'FMEA 작성을 위해 기초 및 Family FMEA를 요구한다.',//html available
                    answer : "1",
                    explain : 'Base Line으로 요구된다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. FMEA 변경 양식 소개</h3>
                        <li>변경된 구조</li>
                        <li>FOCUS ELEMENT 중심의 전개</li>
                        <p class="mg10"></p>
                        <h3>2. FMEA 정보구조</h3>
                        <li>FMEA 목적, 한계, 적용전략</li>
                        <li>D.P FMEA의 이해</li>
                        <p class="mg10"></p>
                        <h3>3. FMEA와 Collaboration 방안</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c07.mp4',
        },
    ]
}